// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"ed0d2b80","566":"e706b8d9","766":"b7d89a0e","850":"6723aea3"}[chunkId] + ".chunk.css";
};